(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsRerunningController',TabObjectsRerunningController);

    TabObjectsRerunningController.$inject = ['$uibModalInstance', 'entity', 'TabObjects'];

    function TabObjectsRerunningController($uibModalInstance, entity, TabObjects) {
        var vm = this;
        vm.tabObjects = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmRerunning = function (objectUniqueCode) {
            TabObjects.rerunning(objectUniqueCode,
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
